import { createAction } from '../../store.model';
import { PerformanceMetricData } from '../models/performance-metric-data.model';
import { ActionType } from '../my-performance-card.action';

export interface GetPerformanceDataAction {
    userId: number;
    metricId?: number;
    queueId?: number;
}

export const getPerformanceData = createAction<
    ActionType,
    GetPerformanceDataAction
>(ActionType.MY_PERFORMANCE_CARD__GET_PERFORMANCE_DATA);

export interface GetPerformanceDataResultAction {
    performanceData: PerformanceMetricData[];
    userId: number;
    metricId?: number;
    queueId?: number;
}

export const getPerformanceDataResult = createAction<
    ActionType,
    GetPerformanceDataResultAction
>(ActionType.MY_PERFORMANCE_CARD__GET_PERFORMANCE_DATA_RESULT);
